import { Toast } from 'antd-mobile';
import {
  ramadanNewInfo,
  ramadanNewRankList,
  ramadanNewsignInfo,
  ramadanNewSupplement,
  ramadanNewCheckin,
  ramadanNewAccumulateReward,
  ramadanNewCollect,
  ramadanRefreshPrizePool,
  ramadanHideGuideTips,
  ramadanNewHallOfFame,
} from '@/services/activity';

export default {
  namespace: 'RamadanNewActivity',
  state: {
    title: '',
    titleUrl: '',
    status: 0, //  0 未开始 1 进行中 2 已结束
    startTime: '',
    endTime: '',
    limitedGifts: [],
    receiveRewards: [],
    sendRewards: [],
    currentDay: {},
    daysInfo: [],
    daysAndReward: [],
    lastId: '',
    isMore: false,
    rankList: [],
    selfInfo: {},
    accumulateList: [],
    checkinList: [],
    hasSupplementableDays: 0,
    supplementable: 0,
    isAutoSign: false,
    prizePool: 0,
    predicateCoins: 0,
    ticketNum: 0,
    guideList: [],
    subActivityId: '',
    subActivityIdToGiftMap: [],
    fameCountDown: '',
    fameStatus: 0,
    currentBlessCount: 0,
    currentBlessTriggerCount: 0,
    rankInfo: [],
    blessHallOfFameVideo: '',
    ramadanGiftPackUrl: '',
    blessHallOfFameBg: '',
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        endTime: payload.countDown || 0,
        // startTime: payload.startTime || 0,
        status: payload.status || 0,
        limitedGifts: payload.limitedGifts || [],
        currentDay: payload.currentDay,
        daysInfo: payload.daysInfo || [],
        receiveRewards: payload.totalReceiveRewards || [],
        sendRewards: payload.totalSendRewards || [],
        hideGuideTips: payload.hideGuideTips || 0, // 是否隐藏新手引导
        showCollectTip: payload.showCollectTip || 0, // 瓜分奖池弹窗是否展示
        guideList: payload.guideList || [],
        blessHallOfFameVideo: payload.blessHallOfFameVideo || '',
        ramadanGiftPackUrl: payload.ramadanGiftPackUrl || '',
        rewardsTitleUrl: payload.rewardsTitleUrl || '',
        congratulationUrl: payload.congratulationUrl || '',
        blessHallOfFameBg: payload.blessHallOfFameBg || '',
      };
    },
    // 签到相关信息
    updateCheckInfo(state, { payload }) {
      let isAutoSign = false;
      if (payload.checkinList && payload.checkinList.length) {
        for (let i = 0, n = payload.checkinList.length; i < n; i++) {
          const it = payload.checkinList[i];
          // 今日没有签到，需要调用自动签到
          if (it.dayStatus == 1 && it.status == 0) {
            isAutoSign = true;
            break;
          }
        }
      }
      return {
        ...state,
        accumulateList: payload.accumulateList || [],
        checkinList: payload.checkinList || [],
        hasSupplementableDays: payload.hasSupplementableDays || 0,
        supplementable: payload.supplementable || 0,
        isAutoSign: isAutoSign,
      };
    },
    updateRefreshInfo(state, { payload }) {
      return {
        ...state,
        prizePool: payload.prizePool || 0,
        predicateCoins: payload.predicateCoins || 0,
        ticketNum: payload.ticketNum || 0,
      };
    },
    updateRankList(state, { payload }) {
      let newList = payload.force ? [] : [...state.rankList];
      let self = {};
      let lastId = '';
      let hasMore = false;
      if (payload.rankInfo && payload.rankInfo.ranks && payload.rankInfo.ranks.length) {
        newList = [...newList, ...payload.rankInfo.ranks];
        lastId = payload.rankInfo.ranks[payload.rankInfo.ranks.length - 1].userId;
        hasMore = payload.rankInfo.ranks.length === 20 ? true : false;
      }
      if (payload.rankInfo && payload.rankInfo.selfInfo) {
        self = payload.rankInfo.selfInfo;
      }

      return {
        ...state,
        daysAndReward: payload.daysAndReward || [],
        rankList: newList,
        selfInfo: self,
        lastId: lastId,
        isMore: hasMore,
      };
    },
    updateHallOfFameInfo(state, { payload }) {
      return {
        ...state,
        subActivityId: payload.subActivityId,
        subActivityIdToGiftMap: payload.subActivityInfos,
        fameCountDown: payload.countDown,
        fameStatus: payload.status,
        currentBlessCount: payload.currentBlessCount,
        currentBlessTriggerCount: payload.currentBlessTriggerCount,
        rankInfo: payload.rankInfo,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(ramadanNewInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getRamadanNewRankList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.RamadanNewActivity);
      const { error, data } = yield call(ramadanNewRankList, {
        ...payload,
        lastId: payload.force ? '' : lastId,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRankList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getHallOfFameInfo({ payload }, { call, put }) {
      const { error, data } = yield call(ramadanNewHallOfFame, payload);
      if (error || !data) {
        yield put({
          type: 'updateHallOfFameInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateHallOfFameInfo',
        payload: data,
      });
      return true;
    },
    *getCheckInfo({ payload }, { call, put }) {
      const { error, data } = yield call(ramadanNewsignInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateCheckInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateCheckInfo',
        payload: data,
      });
      return true;
    },
    // 瓜分奖池数字信息
    *ramadanRefresh({ payload }, { call, put }) {
      const { error, data } = yield call(ramadanRefreshPrizePool, payload);
      if (error || !data) {
        yield put({
          type: 'updateRefreshInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      yield put({
        type: 'updateRefreshInfo',
        payload: data,
      });
      return {
        data,
        success: true,
      };
    },
    // 补签
    *supplement({ payload }, { call }) {
      const { error, code, data } = yield call(ramadanNewSupplement, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    // 签到
    *ramadanNewCheckin({ payload }, { call }) {
      const { error, code, data } = yield call(ramadanNewCheckin, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    // 领取累计奖励
    *ramadanNewAccumulateReward({ payload }, { call }) {
      const { error, code, data } = yield call(ramadanNewAccumulateReward, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    // 领取瓜分奖池
    *ramadanNewCollect({ payload }, { call }) {
      const { error, code, data } = yield call(ramadanNewCollect, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    // 隐藏新手引导
    *ramadanHideGuideTips({ payload }, { call }) {
      const { error, code, data } = yield call(ramadanHideGuideTips, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
  },
};
